<template>
  <fragment>
    <mc-app-header title="Add Flow">
      <template #right>
        <div class="level-item">
          <b-button
            :loading="flows.submitting"
            type="is-primary"
            @click="addFlowHandler"
          >
            Add
          </b-button>
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="add-flow section">
        <form class="mc-container">
          <div class="add-flow__group">
            <b-field>
              <b-input
                v-model="name"
                icon="format-title"
                placeholder="Flow Name"
                type="text"
              />
            </b-field>
            <b-field class="add-flow__switch">
              <b-switch v-model="isPublic">
                <b>Public</b>
              </b-switch>
            </b-field>
          </div>
          <flow-editor
            ref="flowEditor"
            :flow-definition="flowDefinition"
            split-view-height="calc(100vh - 230px)"
          />
        </form>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import FlowEditor from '../../ui/chat/FlowEditor.vue';
import regex from '../../utils/regex';

export default {
  data: function() {
    return {
      name: '',
      isPublic: false,
      flowDefinition: {
        answers: {},
        prompts: {}
      }
    };
  },
  computed: {
    ...mapState(['flows'])
  },
  methods: {
    ...mapActions('flows', ['addFlow']),
    addFlowHandler() {
      if (!this.isNameValid(this.name)) {
        this.$buefy.toast.open({
          message: regex.flowName.message,
          type: 'is-danger'
        });
        return;
      }

      const id = this.name;
      const definition = this.$refs.flowEditor.getDefinition();

      this.$buefy.dialog.confirm({
        message: `
        Make sure that you get the flow name correct before adding it.
        Once added flow names can't be edited.`,
        cancelText: 'Change Flow Name',
        confirmText: 'Add Flow',
        onConfirm: async () => {
          try {
            await this.addFlow({ definition, id, public: this.isPublic });
            this.$buefy.toast.open({
              message: 'Flow added successfully!',
              type: 'is-success'
            });
            this.$router.replace(`/flows/edit/${this.flows.newFlowId}`);
          } catch (error) {
            this.$buefy.toast.open({
              message: 'Failed to add flow!',
              type: 'is-danger'
            });
          }
        }
      });
    },
    isNameValid(name) {
      return regex.flowName.pattern.test(name);
    }
  },
  components: {
    FlowEditor
  }
};
</script>

<style lang="scss" scoped>
.add-flow {
  &__group {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;

    .field {
      flex: 1 0 0;
      margin-bottom: 0;

      &:first-child {
        margin-right: 1rem;
      }
    }
  }

  &__switch {
    display: flex;
    flex-direction: column;
  }
}
</style>
